import React from "react";

export default function FooterLinks() {
  return (
    <div className="FooterLinks">
      <p>
        This project was coded by{" "}
        <a href="https://github.com/NK-01" target="_blank" rel="noreferrer">
          Nidhi Kumari
        </a>{" "}
        and is{" "}
        <a
          href="https://github.com/NK-01/weatherwhiz-react-version"
          target="_blank"
          rel="noreferrer"
        >
          open-sourced on GitHub
        </a>
      </p>
    </div>
  );
}
